import { PhotogoodsListStore as PhotogoodsListStoreState } from '@/types/common/photogoodsList'
import { InjectionKey, reactive } from 'vue'

import { AxiosInstance } from 'axios'
import { useCommonApiError } from '@/hooks/error/common'
import { ApiError } from '@/types/global'

import { PhotogoodsApi } from '@/api/common/photogoods'

export class PhotogoodsListStore {
  photogoodsApi: PhotogoodsApi

  constructor(axios: AxiosInstance) {
    this.photogoodsApi = new PhotogoodsApi(axios)
  }

  public state = reactive<PhotogoodsListStoreState>({
    products: [],
  })

  /**
   * フォトグッズ一覧取得[API]
   */
  public async getPhotogoods(): Promise<void> {
    await this.photogoodsApi
      .getPhotogoods()
      .then((products) => {
        this.state.products = products
      })
      .catch(({ response }: ApiError<null>) => {
        useCommonApiError(response)
      })
  }
}

export const photogoodsListStoreKey: InjectionKey<PhotogoodsListStore> = Symbol('PhotogoodsListStoreKey')
